/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Features_Finance_Collect_WhoInputs */

const en_features_finance_collect_who = /** @type {(inputs: Features_Finance_Collect_WhoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} people`)
};

const pl_features_finance_collect_who = /** @type {(inputs: Features_Finance_Collect_WhoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} osoby`)
};

/**
* | output |
* | --- |
* | "{count} people" |
*
* @param {Features_Finance_Collect_WhoInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_finance_collect_who = /** @type {((inputs: Features_Finance_Collect_WhoInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Finance_Collect_WhoInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_finance_collect_who(inputs)
	return en_features_finance_collect_who(inputs)
});